import React from 'react';

interface TabButtonProps {
  title: string;
  active: boolean;
  disabled?: boolean;
  toolTip?: string;
}

function TabButton(props: TabButtonProps) {
  const { title, active } = props;
  return (
    <div
      id="tabbutton-main"
      className={`m-0 inline py-2 px-5 w-72 text-center text-gray-500 font-bold hover:bg-gray-100 hover:cursor-pointer ${
        active ? '!text-blue-700' : ''
      }`}
      style={{
        borderBottom: active ? '2px solid blue' : '2px solid transparent',
      }}
    >
      {title}
    </div>
  );
}

export default TabButton;
